import { invitations, roles } from "@/enums/roles";

export const getDisplayRole = (role: string) => {
  switch (role) {
    case roles.SUPER_ADMIN:
      return {
        label: "Super Admin",
        className: "bg-green-100 text-green-800",
      };
    case roles.ORG_ADMIN:
      return {
        label: "Organization Admin",
        className: "bg-yellow-100 text-yellow-800",
      };
    case roles.BRANCH_ADMIN:
      return {
        label: "Branch Admin",
        className: "bg-red-100 text-yellow-800",
      };
    case roles.MEMBER:
      return { label: "Member", className: "bg-blue-100 text-blue-800" };
    default:
      return {
        label: "Unknown Role",
        className: "bg-gray-100 text-gray-800",
      };
  }
};

export const DisplayInvitationStatus = (status: string) => {
  switch (status) {
    case invitations.EXPIRED:
      return {
        label: "Expired",
        className: "bg-red-400 text-red-800",
      };
    case invitations.PENDING:
      return {
        label: "Pending",
        className: "bg-yellow-400 text-yellow-800",
      };
    case invitations.USED:
      return {
        label: "Used",
        className: "bg-green-400 text-green-800",
      };
    default:
      return {
        label: "Unknown Status",
        className: "bg-gray-400 text-gray-800",
      };
  }
};
